import React from 'react';
import { Check } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { Card } from '../components/ui/card';

const Services = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="relative h-[50vh] flex items-center justify-center overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1497366754035-f200968a6e72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHxjb21tZXJjaWFsJTIwYnVpbGRpbmd8ZW58MHx8fHwxNzcwNDAzNzgwfDA&ixlib=rb-4.1.0&q=85')`,
          }}
        >
          <div className="absolute inset-0 bg-black/60" />
        </div>

        <div className="relative z-10 text-center text-white px-4 max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold mb-4 tracking-tight">
            {t.services.title}
          </h1>
          <p className="text-xl md:text-2xl text-gray-200 font-light">
            {t.services.subtitle}
          </p>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {t.services.list.map((service, index) => (
              <Card
                key={index}
                className="p-8 border-gray-200 hover:shadow-xl transition-all duration-300 group"
                style={{
                  animation: `fadeInUp 0.6s ease-out ${index * 0.15}s backwards`,
                }}
              >
                <div className="space-y-6">
                  <h3 className="text-3xl font-bold text-gray-900 group-hover:text-black transition-colors">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed text-lg">
                    {service.description}
                  </p>
                  
                  {/* Features List */}
                  <div className="pt-4 border-t border-gray-200">
                    <ul className="space-y-3">
                      {service.features.map((feature, idx) => (
                        <li key={idx} className="flex items-start space-x-3">
                          <div className="flex-shrink-0 w-5 h-5 bg-gray-900 rounded-full flex items-center justify-center mt-0.5">
                            <Check className="h-3 w-3 text-white" />
                          </div>
                          <span className="text-gray-700">{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              {t.services.title}
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="relative h-96 overflow-hidden rounded-lg shadow-lg">
              <img
                src="https://images.unsplash.com/photo-1651093791352-2ae1c9e5e428?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHxyZXNpZGVudGlhbCUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3NzA0MDM3NzF8MA&ixlib=rb-4.1.0&q=85"
                alt="Residential project"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="relative h-96 overflow-hidden rounded-lg shadow-lg">
              <img
                src="https://images.unsplash.com/photo-1497366811353-6870744d04b2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHw0fHxjb21tZXJjaWFsJTIwYnVpbGRpbmd8ZW58MHx8fHwxNzcwNDAzNzgwfDA&ixlib=rb-4.1.0&q=85"
                alt="Commercial project"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gray-900 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">
            {t.contact.cta}
          </h2>
          <p className="text-xl text-gray-300 mb-8">
            {t.contact.subtitle}
          </p>
        </div>
      </section>
    </div>
  );
};

export default Services;
